import React from "react"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"

import {
  addComboToOrder,
  editComboOrder,
  foodSidebarScrollToButtom
} from "@redux"
import { Button } from "components"
import { createComboData } from "utils"

const ComboModalDoneButton = props => {
  const {
    combo,
    editMode,
    orderComboIndex,
    setOpenModal,
    selectedComboItems
  } = props

  const validate = () => {
    const numberOfComboSets = combo.comboSets.length

    let empty = false

    for (const selectedComboItem of selectedComboItems) {
      if (!!selectedComboItem) continue

      empty = true
      break
    }

    const result =
      empty ||
      numberOfComboSets !== selectedComboItems.length

    if (result) {
      toast.error("لطفا از هر آپشن یک آیتم را انتخاب کنید", { autoClose: false })

      return false
    }

    return true
  }

  const handleDone = () => {
    if (!validate()) return

    const newCombo =
      createComboData(combo, selectedComboItems)

    if (editMode) {
      dispatch(
        editComboOrder(orderComboIndex, newCombo)
      )
    } else {
      dispatch(
        addComboToOrder(newCombo)
      )

      dispatch(
        foodSidebarScrollToButtom()
      )
    }

    setOpenModal(false)
  }

  const dispatch = useDispatch()

  return (
    <Button
      color="success"
      onClick={handleDone}
    >
      افزودن
    </Button>
  )
}

export default ComboModalDoneButton